/**
 * @module
 * @format
 */

// @ts-ignore deprecated Stargazer export
import {COMPILE, SCOPE, UPGRADE, NodeUpgrade} from '@acng/frontend-stargazer';
import {get} from '@acng/frontend-bounty/dom/attribute.js';
import {ENUM, guard} from '@acng/frontend-rubicon';

/**
 * @import {InternalEngine as Engine, Controller} from "@acng/frontend-stargazer";
 */

import {fetchGlobalFeed} from './store.js';
import {Actor} from '../layout/context/list.js';
import {user} from '../user/user.js';

const provideList = Actor();

/**
 * @implements {Controller}
 */
class GlobalFeed {
  /**
   * @param {Element} element
   */
  [UPGRADE](element) {
    const {niche, fsk} = user;
    const filter = get(element, 'data-feed-type') ?? 'latest';
    const limit = filter == 'latest' ? 100 : 1000;

    ASSERT: {
      const options = /** @type {const} */ (['all', 'posts', 'media', 'favorites', 'latest']);
      guard(filter, ENUM(options));
    }

    provideList(
      element,
      (offset) => fetchGlobalFeed(filter, niche, fsk, offset, limit),
      async (item) => {
        await item[COMPILE]();

        /**
         * @param {Element} element
         * @param {Engine} engine
         */
        return (element, engine) => {
          item[UPGRADE](element);
          NodeUpgrade(engine, item[SCOPE]);
        };
      },
    );
  }
}

export {GlobalFeed};
